module.exports = {
  StudentServicesHomepageComponentEvents: {
    CosubDialog: {
      code: 'CosubDialog',
      events: {
        Accept: {
          description: 'Triggered when user accepts the cosub invitation dialog.',
          eventHub: {
            code: 'Accept',
            action: 'SSDashboard_CosubInviteAccept'
          },
          ga: {
            action: 'SSDashboard_CosubInviteAccept'
          }
        }
      }
    },
    CoSubInviteCard: {
      code: 'CoSubInviteCard',
      events: {
        GetStarted: {
          description: 'Triggered when user clicks Get started.',
          eventHub: {
            code: 'GetStarted',
            action: 'SSDashboard_CosubInviteGetStarted'
          },
          ga: {
            action: 'SSDashboard_CosubInviteGetStarted'
          }
        }
      }
    },
    ChildProfile: {
      code: 'StudentProfileCard',
      events: {
        StudentProfileCardViewDetailsClick: {
          description: 'Triggered when user clicks on view details on the student card.',
          eventHub: {
            code: 'StudentProfileCardFilled',
            action: '[$.action]',
            dataKeys: ['userId', 'sessionId', 'studentName', 'action']
          },
          ga: {
            action: 'SPC - [$.action] Button Click'
          }
        },
        StudentProfileCardExploreCareersClick: {
          description: 'Triggered when user clicks on explore careers on the student card.',
          eventHub: {
            code: 'StudentProfileCardEmpty',
            action: '[$.action]',
            dataKeys: ['userId', 'sessionId', 'studentName', 'action']
          },
          ga: {
            action: 'SPC - [$.action] Button Click'
          }
        }
      }
    },
    FeatureCard: {
      code: 'FeatureCard',
      events: {
        BtnClick: {
          description: 'Triggered when gifting feature card button is clicked.',
          eventHub: {
            code: 'Click',
            action: 'FeatureCard_Homepage_Btn',
            dataKeys: ['service']
          },
          ga: {
            action: 'Services - Click on [$.service] button'
          }
        }
      }
    },
    GiftNoRESP: {
      code: 'GiftNoRESP',
      events: {
        Dialog: {
          description: 'Triggered when Gift No RESP dialog is opened or closed.',
          eventHub: {
            code: 'Dialog',
            action: 'Gifting_Subscriber_No_RESP_[$.action]',
            dataKeys: ['action']
          },
          ga: {
            action: 'Services - Gift No RESP dialog is [$.action]'
          }
        },
        OpenRESP: {
          description: 'Triggered when the user clicks the "Open an RESP" button.',
          eventHub: {
            code: 'OpenRESP',
            action: 'Gifting_Subscriber_No_RESP_Open_RESP',
            dataKeys: []
          },
          ga: {
            action: 'Services - Clicked Open RESP'
          }
        }
      }
    }
  }
};
